export const TICKET_DETAILS_STEP = 0;

export const TICKET_PRICES_STEP = 1;

export const ASSIGN_DATES_STEP = 2;
